import { Box } from "@chakra-ui/react"

export const SeparetorMarginBottom = (props?: any) => {
    return(
        <Box marginBottom={{base: 8, md: props.value || 4 }} />
    )
}